<template>
  <div class="widget product-statistic" ref="widget">
    <div class="widget-title" v-if="settings.value.show_title_block" >
      {{ settings.value.show_title_block }}
    </div>
    <div class="widget-content" :class="{'_full-content': !settings.value.show_title_block}">
      <div
        class="product-item entity-item item"
        v-for="(product, i) in filteredProducts"
        :key="product.product"
        :class="{
          '_gold': i == 0 && settings.value.show_prize_places,
          '_silver': i == 1 && settings.value.show_prize_places,
          '_bronze': i == 2 && settings.value.show_prize_places
        }"
      >
        <div class="position">{{ i + 1 }}</div>
        <div class="item-label">
          <p class="name">{{ product.product }}</p>
        </div>

        <div class="item-data">
          <!--  -->
          <div
            class="col"
            v-if="settings.value.show_daily"
            :class="getColor(product[useNetAmount('daily')])"
          >
            <div class="type">Daily:</div>
            <div class="targ">
              <span class="targ-val">
                <template v-if="currency">
                  {{ (product[useNetAmount("daily")].curr || 0) | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('daily_count')].curr || 0) | numFormat }}
                </template>
                <span class="word-sales" v-if="!currency">Sales</span>
              </span>
              <span class="condition">
                (
                <v-icon class="up">fa-caret-up</v-icon>
                <v-icon class="down">fa-caret-down</v-icon>
                <template v-if="currency">
                  {{ (product[useNetAmount("daily")].diff ? Math.abs(product[useNetAmount("daily")].diff * 100) : 0) | numFormat }}%)
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('daily_count')].diff ? Math.abs(product[this.useByPaymentCapacity('daily_count')].diff * 100) : 0) | numFormat }}%)
                </template>
              </span>
            </div>
          </div>
          <!--  -->
          <div
            class="col"
            v-if="settings.value.show_weekly"
            :class="getColor(product[useNetAmount('weekly')])"
          >
            <div class="type">Weekly:</div>
            <div class="targ">
              <span class="targ-val">
                <template v-if="currency">
                  {{ (product[useNetAmount("weekly")].curr || 0) | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('weekly_count')].curr || 0) | numFormat }}
                </template>
                <span class="word-sales" v-if="!currency">Sales</span>
              </span>
              <span class="condition">
                (
                <v-icon class="up">fa-caret-up</v-icon>
                <v-icon class="down">fa-caret-down</v-icon>
                <template v-if="currency">
                  {{ (product[useNetAmount("weekly")].diff ? Math.abs(product[useNetAmount("weekly")].diff * 100) : 0) | numFormat }}%)
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('weekly_count')].diff ? Math.abs(product[this.useByPaymentCapacity('weekly_count')].diff * 100) : 0) | numFormat }}%)
                </template>
              </span>
            </div>
          </div>
          <div
            class="col"
            v-if="settings.value.show_monthly"
            :class="getColor(product[useNetAmount('monthly')])"
          >
            <div class="type">Monthly:</div>
            <div class="targ">
              <span class="targ-val">
                <template v-if="currency">
                  {{ (product[useNetAmount("monthly")].curr || 0) | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('monthly_count')].curr || 0) | numFormat }}
                </template>
                <span class="word-sales" v-if="!currency">Sales</span>
              </span>
              <span class="condition">
                (
                <v-icon class="up">fa-caret-up</v-icon>
                <v-icon class="down">fa-caret-down</v-icon>
                <template v-if="currency">
                  {{ (product[useNetAmount("monthly")].diff ? Math.abs(product[useNetAmount("monthly")].diff * 100) : 0) | numFormat }}%)
                </template>
                <template v-else>
                  {{ (product[this.useByPaymentCapacity('monthly_count')].diff ? Math.abs(product[this.useByPaymentCapacity('monthly_count')].diff * 100) : 0) | numFormat }}%)
                </template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, orderBy } from "lodash";
import { mapGetters, mapActions } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    widget_uuid() {
      return this.settings.value.widget_uuid;
    },
    filteredProducts() {
      // const streams = this.streams?.streams;

      // const streamProducts = streams.statistic.products.map(el => el) || [];

      // const needleProducts = this.settings.value.which_products_need_show.map(el => el) || [];

      // const defaultItemStat = {
      //   curr: 0,
      //   prev: 0,
      //   diff: 0,
      // };

      // const defaultProduct = {
      //   daily_count: defaultItemStat,
      //   gross_daily_sale: defaultItemStat,
      //   gross_monthly_sale: defaultItemStat,
      //   gross_weekly_sale: defaultItemStat,
      //   monthly_count: defaultItemStat,
      //   net_daily_sale: defaultItemStat,
      //   net_monthly_sale: defaultItemStat,
      //   net_weekly_sale: defaultItemStat,
      //   weekly_count: defaultItemStat,
      // };

      let productsStatistic = this.$store.state?.productsStatistic?.data;
      if (!productsStatistic) { return }
      let products = productsStatistic[this.widget_uuid] || [];

      const useNetAmount = this.useNetAmount;
      let filters = [
        (product) => get(product, ["net_monthly_sale", "curr"], 0),
        (product) => get(product, ["net_weekly_sale", "curr"], 0),
        (product) => get(product, ["net_daily_sale", "curr"], 0),
      ];

      if (!useNetAmount) {
        filters = [
          (product) => get(product, ["gross_monthly_sale", "curr"], 0),
          (product) => get(product, ["gross_weekly_sale", "curr"], 0),
          (product) => get(product, ["gross_daily_sale", "curr"], 0),
        ];
      }

      return orderBy(products, filters, ["desc", "desc", "desc"]).slice(
        0,
        parseInt(this.settings.value.max_product_in_list)
      );
    },
  },
  data() {
    return {
      products: [],
    };
  },
  methods: {
    ...mapActions({
      updateProductStatistic: "productsStatistic/updateProductStatistic",
    }),
    margin() {
      const { widget } = this.$refs;
      if (
        widget &&
        this.$variables.appHeight > 0 &&
        this.$variables.appWidth > 0
      ) {
        return (
          widget.offsetParent.offsetParent.offsetHeight <
          widget.offsetParent.scrollHeight
        );
      }
    },
    getColor(obj) {
      if (!obj.diff) return "_pos";
      const cost = obj.diff * 100;
      if (cost < 0) { return "_neg"; }
      return "_pos";
    },
  },
  mounted() {
    this.updateProductStatistic(this.settings.board_id);

    let products = this.streams;

    let data = products.streams.statistic.products;
    let i = 0;
    for (let key in data) {
      if (
        !this.settings.value.which_products_need_show
          .map((product) => String(product).trim().toLowerCase())
          .includes(String(data[key].product).trim().toLowerCase())
      ) {
        continue;
      }
      if (i == 0) data[key]['_gold'] = 1;
      else if (i == 1) data[key]['_silver'] = 1;
      else if (i == 2) data[key]['_bronze'] = 1;
      data[key].order = i + 1;
      if (i >= this.settings.value.max_product_in_list) break;
      i++;
    }

    this.products = data;

    // this.getInfo();
  },
};
</script>


<style lang="scss">
.product-statistic {
  .product-item {
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      .targ-val {
        color: #00000099;
      }
      &._gold {
        .type {
          text-shadow: 0px 0px 10px #946e24;
        }
      }
      &._silver {
        .type {
          text-shadow: 0px 0px 10px #707070;
        }
      }
      &._bronze {
        .type {
          text-shadow: 0px 0px 10px #b4712f;
        }
      }
    }
  }
  .type {
    color: #fff;
  }
  .item-data {
    padding-top: 10px;
    .targ-val {
      color: #fff;
      margin-right: 5px;
      font-size: 24px;
      .word-sales {
        font-size: 0.7em;
        font-weight: 700;
      }
    }
    .condition {
      .v-icon {
        margin-right: 2px;
      }
    }
  }
  &.item-cols-3,
  &.item-cols-4 {
    .targ {
      flex-direction: column;
    }
    .targ-val {
      font-size: 18px;
      text-align: center;
    }
  }
  .col {
    .v-icon {
      display: none;
    }
    &._pos {
      color: #3caf3c;
      .up {
        display: inline;
      }
    }
    &._neg {
      color: red;
      .down {
        display: inline;
      }
    }
  }

  .product-period-type-container {
    // #8dee8d
    // color: #3caf3c !important;
  }

  .negative p span {
    // #f74242;
    color: red !important;
  }

  ._pos .condition {
    color: #3caf3c;
  }

  ._neg .condition {
    color: red;
  }

  ._pos .condition i {
    color: #3caf3c;
  }

  ._neg .condition i {
    color: red;
  }
}
</style>
